<div class="blog-content-wrap">
  <div class="container">
    <div class="row">
      <div class="col-12">
        <div class="wrap-socials d-flex">
          <div class="d-flex sociallinks">
            <a
              class="link-icon"
              href="https://www.linkedin.com/shareArticle?mini=true&url={{
                data?.link
              }}"
              onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600')"
              target="_blank"
              title="Share on Linkdin"
            >
              <i class="fab fa-linkedin-in"></i>
            </a>
            <a
              class="link-icon"
              href="https://twitter.com/share?url={{ data?.link }}"
              onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600')"
              target="_blank"
              title="Share on Twitter"
            >
            <svg width="14" height="12" viewBox="0 0 14 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M8.4509 4.83401L12.6877 0H10.434L7.40291 3.48587L4.71441 0.0271486H0.388662L5.149 6.07812L0 12H2.17023L6.19499 7.4077L9.78608 11.9727H14L8.4509 4.83401ZM2.73788 1.1786H4.26675L11.6504 10.8214H10.3452L2.73788 1.1786Z" fill="#0066ff"/>
            </svg>
              
              <!-- <i class="fab fa-twitter"></i> -->
            </a>
            <a
              href="https://www.facebook.com/sharer/sharer.php?u={{
                data?.link
              }}"
              class="link-icon"
              onclick="javascript:window.open(this.href, '', 'menubar=no,toolbar=no,resizable=yes,scrollbars=yes,height=300,width=600')"
              target="_blank"
              title="Share on Facebook"
            >
              <i class="fab fa-facebook-f"></i>
            </a>
          </div>
        </div>
        <div class="wrap-summary" [innerHTML]="data.content.rendered"></div>
      </div>
    </div>
  </div>
</div>
